import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AiOutlineForm } from "react-icons/ai";

const HomeBarrelBlanket = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');

    useEffect(() => {
        const storedUsername = localStorage.getItem("apUsername");
        if (storedUsername) {
            setUsername(storedUsername);
        }
    }, []);

    return (
        <div className="min-h-screen bg-gray-100">
            {/* Header */}
            <div className="bg-teal-600 text-white p-4 shadow-md">
                <div className="flex justify-between items-center">
                    <h1 className="text-2xl font-bold">Barrel Blanket</h1>
                    <div className="flex items-center gap-2">
                        <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center">
                            <span className="text-teal-600 font-bold text-lg">
                                {username ? username.charAt(0).toUpperCase() : 'U'}
                            </span>
                        </div>
                        <span className="font-semibold">{username || 'User'}</span>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="flex flex-col items-center justify-center min-h-[calc(100vh-80px)] p-5 gap-6">
                <button
                    onClick={() => navigate('/barrel-blanket/form')}
                    className="w-full max-w-md px-6 py-4 bg-teal-600 text-white rounded-lg font-semibold text-lg hover:bg-teal-700 transition-colors flex items-center justify-center gap-3 shadow-md"
                >
                    <AiOutlineForm className="text-xl" />
                    <span>New Barrel Blanket Form</span>
                </button>

                <button
                    onClick={() => navigate('/barrel-blanket/drafts')}
                    className="w-full max-w-md px-6 py-4 bg-teal-600 text-white rounded-lg font-semibold text-lg hover:bg-teal-700 transition-colors flex items-center justify-center gap-3 shadow-md"
                >
                    <AiOutlineForm className="text-xl" />
                    <span>Drafts</span>
                </button>

                <button
                    onClick={() => navigate('/barrel-blanket/my-entries')}
                    className="w-full max-w-md px-6 py-4 bg-teal-600 text-white rounded-lg font-semibold text-lg hover:bg-teal-700 transition-colors flex items-center justify-center gap-3 shadow-md"
                >
                    <AiOutlineForm className="text-xl" />
                    <span>My Submitted Entries</span>
                </button>

                <button
                    onClick={() => navigate('/barrel-blanket/all-entries')}
                    className="w-full max-w-md px-6 py-4 bg-teal-600 text-white rounded-lg font-semibold text-lg hover:bg-teal-700 transition-colors flex items-center justify-center gap-3 shadow-md"
                >
                    <AiOutlineForm className="text-xl" />
                    <span>All Entries</span>
                </button>
            </div>
        </div>
    );
};

export default HomeBarrelBlanket;



